module.exports = __webpack_public_path__ + "img/FS1.78368927.jpg";